import { render, staticRenderFns } from "./traineePostassessment.vue?vue&type=template&id=8d33217e&scoped=true"
import script from "./traineePostassessment.vue?vue&type=script&lang=js"
export * from "./traineePostassessment.vue?vue&type=script&lang=js"
import style0 from "./traineePostassessment.vue?vue&type=style&index=0&id=8d33217e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d33217e",
  null
  
)

export default component.exports